"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

/** Locks document chrome to Mindaloo × Karma AC OS (no legacy Mindaloo AC shell bleed). */
export default function MindalooOsChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const active = pathname?.startsWith("/mindaloo") ?? false;

  useEffect(() => {
    if (!active) return;
    const html = document.documentElement;
    html.classList.add("mindaloo-os");
    document.body.classList.add("mindaloo-os-body");
    return () => {
      html.classList.remove("mindaloo-os");
      document.body.classList.remove("mindaloo-os-body");
    };
  }, [active]);

  if (!active) return <>{children}</>;
  return <div className="mindaloo-os-root">{children}</div>;
}
